import { withI18nMessage } from '@/plugins/vuelidate';
import * as validators from '@vuelidate/validators';

export const shiftMaxQuantity = withI18nMessage(validators.maxValue, {
  withArguments: true,
});
